<template>
  <div
    class="buscador row btn-group input-group col-lg-12 mx-auto px-0 my-4"
    role="group"
    aria-label="first group"
  >
    <div class="col px-0">
      <div class="buscador col row btn-group w-100 px-0 mx-0">
        <div class="col-12 col-lg-3 pr-lg-3 px-0 mb-3">
          <b-form-select
            v-model="busqueda.region"
            class="custom-select multiple region rounded-0"
            @change="cambiarRegion"
          >
            <option disabled value="null">Región</option>
            <option
              v-for="r in regiones"
              :key="r.idRegion"
              :value="r.valorBusqueda"
            >{{limpiarNombreRegion(r.nombreRegion)}}</option>
            <option value="TODAS">Todas</option>
          </b-form-select>
        </div>

        <div class="buscador btn-group col-lg-3 mb-3 px-0 pr-lg-3">
          <div class="w-100 px-0">
            <b-form-select
              v-model="busqueda.beneficiosEstatales"
              class="custom-select multiple gratuidad"
              @change="cambiarBeneficios"
            >
              <option disabled value="null">Beneficios del Estado</option>
              <option
                v-for="opcion in optionsBeneficios"
                :key="opcion.index"
                :value="opcion.valor"
              >{{opcion.texto}}</option>
            </b-form-select>
          </div>
        </div>

        <div class="col-12 col-lg px-0 mb-3">
          <Autocompletado
            :nombreCarrera="busqueda.nombreInstitucion"
            :matches="itemsAutocomplete"
            textoPlaceHolder="Nombre de la Institución"
            @selected="buscarNombreInstitucion"
            @asignarTextoIncompleto="asignarTextoIncompleto"
            @change="buscarAutocompletado"
          />
        </div>

        <div class="input-lg ml-3 pr-0 flex-shrink-1 d-none d-lg-block">
          <button
            class="btn btn-blue rounded-0 px-3 py-2"
            type="button"
            id="inputGroupFileAddon"
            v-b-tooltip.hover
            title="Buscar"
            @click="validarFormulario"
          >
            <FontAwesomeIcon icon="search" class="mt-1" />
          </button>
        </div>

        <div class="col-12 input-lg align-self-center px-0 d-block d-lg-none">
          <button
            class="btn btn-blue rounded-0"
            type="button"
            id="inputGroupFileAddonMov"
            v-b-tooltip.hover
            title="Buscar"
            @click="validarFormulario"
          >
            <FontAwesomeIcon icon="search" class="mt-1" />
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import Busqueda from "@/utils/Busqueda.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import ApiBuscador from "@/services/ApiBuscador";
import Autocompletado from "@/components/generales/Autocompletado";
import MixinRegiones from "@/mixins/regiones.js";
import MixinTags from "@/mixins/tags.js";
library.add(faSearch, faPlus);
export default {
  name: "FormBusqueda",
  mixins: [MixinRegiones, MixinTags],
  components: {
    FontAwesomeIcon,
    Autocompletado
  },
  data() {
    return {
      busqueda: {
        region: null,
        beneficiosEstatales: null,
        nombreInstitucion: ""
      },
      listaCampos: ["REGION", "BENEFICIOS_ESTATALES", "NOMBRE_INSTITUTO"],
      itemsAutocomplete: []
    };
  },
  async created() {
    this.reiniciarValores();
  },
  watch: {
    getBusquedasAplicadas(lista) {
      if (lista.length >= 1) {
        let filtros = lista.map(f => f.tipo);
        this.listaCampos.forEach(c => {
          if (!filtros.includes(c)) {
            switch (c) {
              case "REGION":
                this.busqueda.region = null;
                break;
              case "BENEFICIOS_ESTATALES":
                this.busqueda.beneficiosEstatales = null;
                break;
              case "NOMBRE_INSTITUTO":
                this.busqueda.nombreInstitucion = "";
                break;
              default:
                break;
            }
          }
        });
      } else {
        this.limpiarCampos();
      }
      this.buscarInstitucion();
    }
  },
  computed: {
    optionsBeneficios() {
      return Busqueda.criterioBeneficiosDelEstado();
    },
    optionsTipoInstitucion() {
      return Busqueda.criteriosTipoIntitucion();
    }
  },
  methods: {
    async buscarAutocompletado(valor) {
      let res = await ApiBuscador.getNombreUniversidadesAutocompletado(valor);
      if (res !== "") {
        this.itemsAutocomplete = res;
      } else {
        this.itemsAutocomplete = [];
      }
    },
    validarFormulario() {
      if (this.busqueda.nombreInstitucion !== "") {
        this.buscarNombreInstitucion(this.busqueda.nombreInstitucion);
      } else {
        this.buscarInstitucion();
      }
    },
    buscarInstitucion() {
      this.$emit("buscarInstitucion", this.busqueda);
    },
    cambiarRegion(val) {
      let filtro;
      if (val !== "TODAS") {
        let valor = this.regiones.find(i => i.valorBusqueda === val);
        filtro = {
          valor: valor.valorBusqueda,
          texto: this.limpiarNombreRegion(valor.nombreRegion)
        };
      } else {
        filtro = {
          valor: val,
          texto: "REGIÓN: Todas"
        };
      }
      this.guardarBusquedaTags(filtro, "REGION");
    },
    cambiarBeneficios(val) {
      let filtro = this.optionsBeneficios.find(i => i.valor === val);
      if (filtro.valor === "TODOS") {
        filtro.texto = "Beneficios del Estado: Todos";
      }
      this.guardarBusquedaTags(filtro, "BENEFICIOS_ESTATALES");
    },
    buscarNombreInstitucion(val) {
      let filtro = {
        valor: val,
        texto: val
      };
      this.busqueda.nombreInstitucion = val;
      this.guardarBusquedaTags(filtro, "NOMBRE_INSTITUTO");
    },
    asignarTextoIncompleto(val) {
      this.busqueda.nombreInstitucion = val;
    },
    reiniciarValores() {
      let busquedasAplicadas = this.getBusquedasAplicadas;
      if (busquedasAplicadas.length >= 1) {
        busquedasAplicadas.forEach(f => {
          switch (f.tipo) {
            case "REGION":
              this.busqueda.region = f.filtro;
              break;
            case "BENEFICIOS_ESTATALES":
              this.busqueda.beneficiosEstatales = f.filtro;
              break;
            case "NOMBRE_INSTITUTO":
              this.busqueda.nombreInstitucion = f.filtro;
              break;
            default:
              break;
          }
        });
      }
    },
    limpiarCampos() {
      this.busqueda.region = null;
      this.busqueda.beneficiosEstatales = null;
      this.busqueda.nombreInstitucion = "";
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/buscadorInstU/FormBusqueda.vue